module.exports = __webpack_public_path__ + "static/media/0-12631.36d5fee7.jpg";